export let availableParseServerVersions = [
  // {
  //   allowed: true,
  //   className: 'AppVersions',
  //   imageTag: 'release-2.3.3',
  //   latest: true,
  //   objectId: 'release-2.3.3',
  //   version: '2.3.3',
  // },
  // {
  //   allowed: true,
  //   className: 'AppVersions',
  //   imageTag: 'release-2.2.25',
  //   objectId: 'release-2.2.25',
  //   version: '2.2.25',
  // },
];

export const setAvailableParseServerVersions = (versionsArr) => {
  availableParseServerVersions = versionsArr;
};

export const getAvailableParseServerVersions = async () => {
  const result = {};

  availableParseServerVersions.forEach((item) => {
    result[item.imageTag] = item;
  });

  return { ...result };
};

export const findParseServerVersion = (version) => {
  const result = availableParseServerVersions.filter((item) => {
    if (item.imageTag === version) {
      return item;
    }
  });

  return result[0] || {};
};


export const Anchors = {
  TOP: 'TOP',
  RIGHT: 'RIGHT',
  BOTTOM: 'BOTTOM',
  LEFT: 'LEFT',
};

export const AsyncStatus = {
  WAITING: 'WAITING',
  PROGRESS: 'PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

export const ChartColorSchemes = [
  '#169cee',
  '#EDA515',
  '#00DB7C',
  '#FF395E',
  '#555572',
  '#0E69A1',
  '#ED6815',
  '#11C24C',
  '#15D0ED',
  '#5858ED',
  '#15EDC8',
  '#B515ED',
];

export const Directions = {
  TOP_LEFT: 'TOP_LEFT',
  UP: 'UP',
  TOP_RIGHT: 'TOP_RIGHT',
  RIGHT: 'RIGHT',
  BOTTOM_RIGHT: 'BOTTOM_RIGHT',
  DOWN: 'DOWN',
  BOTTOM_LEFT: 'BOTTOM_LEFT',
  LEFT: 'LEFT',
};

export const SpecialClasses = {
  _User: 'User',
  _Installation: 'Installation',
  _Role: 'Role',
  _Product: 'Product',
  _Session: 'Session',
};

export const DefaultColumns = {
  All: ['objectId', 'ACL', 'createdAt', 'updatedAt'],

  _User: ['username', 'password', 'email', 'emailVerified', 'authData'],
  _Installation: ['installationId', 'deviceToken', 'channels', 'deviceType', 'pushType', 'GCMSenderId', 'timeZone', 'localeIdentifier', 'badge'],
  _Role: ['name', 'users', 'roles'],
  _Product: ['order', 'productIdentifier', 'icon', 'title', 'subtitle', 'download', 'downloadName'],
  _Session: ['restricted', 'user', 'installationId', 'sessionToken', 'createdWith'],
};

export const DataTypes = [
  'Boolean',
  'String',
  'Number',
  'Date',
  'Object',
  'Array',
  'GeoPoint',
  // 'Polygon',
  'File',
  'Pointer',
  'Relation',
];

export const swift = ({ serverURL, applicationId, clientKey }) =>
  `let configuration = ParseClientConfiguration {
  $0.applicationId = "${applicationId}"
  $0.clientKey = "${clientKey}"
  $0.server = "${serverURL}"
}
Parse.initializeWithConfiguration(configuration)`;

export const objectivec = ({ serverURL, applicationId, clientKey }) =>
  `[Parse initializeWithConfiguration:[ParseClientConfiguration
    configurationWithBlock:^(id<ParseMutableClientConfiguration> configuration) {
    configuration.applicationId = @"${applicationId}";
    configuration.clientKey = @"${clientKey}";
    configuration.server = @"${serverURL}";
}]];`;

export const java = ({ serverURL, applicationId, clientKey }) =>
  `Parse.initialize(new Parse.Configuration.Builder(myContext)
    .applicationId("${applicationId}")
    .clientKey("${clientKey}")
    .server("${serverURL}")
    ...
    .build()
);`;

export const csharp = ({ serverURL, applicationId, windowsKey }) =>
  `ParseClient.initialize(new ParseClient.Configuration {
    ApplicationId = "${applicationId}",
    WindowsKey = "${windowsKey}",
    Server = "${serverURL}"
});`;

export const javascript = ({ serverURL, applicationId, javascriptKey }) =>
  `Parse.initialize(
  "${applicationId}",
  "${javascriptKey}"
);
Parse.serverURL = '${serverURL}';`;

export const php = ({
  serverURL, applicationId, restKey, masterKey,
}) =>
  `ParseClient::initialize(
  '${applicationId}',
  '${restKey}',
  '${masterKey}'
);
ParseClient::setServerURL('${`${serverURL.slice(0, -2)}', '1`}');`;

export const c = ({ serverURL, applicationId, clientKey }) =>
  `void setup() {
  Parse.begin("${applicationId}", "${clientKey}");
  ??? ${serverURL} ???
}`;

const prices = {
  defaults: {
    initial: { price: 495 },
    requests: { price: 30 },
    storage_db: { price: 1600 },
    storage_s3: { price: 6 },
    transfer: { price: 13 },
    background_jobs: { price: 1000 },
    db_backup: { price: 395 },
    db_backup_initial: { price: 1500 },
  },
  regions: {
    '1-jp': {
      initial: { price: 1495 },
      requests: { price: 42 },
      storage_db: { price: 2200 },
      storage_s3: { price: 8 },
      transfer: { price: 18 },
      background_jobs: { price: 1400 },
      db_backup: { price: 495 },
      db_backup_initial: { price: 2100 },
    },
    '1-au': {
      __extends__: '1-jp',
    },
  },
};

export const app_pricing = (region) => {
  const pricing = Object.assign(
    {},
    prices.defaults,
    prices.regions[(prices.regions[region] || {}).__extends__] || {},
    prices.regions[region] || {},
  );

  delete pricing.__extends__;

  return pricing;
};

export const regionsListData = [
  {
    key: '1-eu',
    value: 'Europe',
    api: 'https://1-eu-api.sashido.io',
  },
  {
    key: '2-us',
    value: 'North America',
    api: 'https://2-us-api.sashido.io',
  },
  {
    key: '3-us',
    value: 'South America',
    api: '',
  },
  {
    key: '1-jp',
    value: 'Asia',
    api: 'https://1-jp-api.sashido.io',
  },
  {
    key: '1-au',
    value: 'Australia',
    api: 'https://1-au-api.sashido.io',
  },
];

const addPriceToRegions = () => {
  const result = regionsListData.map((i) => {
    i.value_after = `$${(app_pricing(i.key).initial.price / 100).toFixed(2)}/mo`;
    return i;
  });

  return result;
};

export const regionsList = addPriceToRegions();

export const getRegion = regionsList.reduce((b, i) => { b[i.key] = i; return b; }, {});

// export const availableRegions = ['1-eu', '2-us', '1-jp', '1-au'];
export const availableRegions = ['1-eu', '2-us'];

export const addonTitles = {
  'backups-enabled': 'Enabled automatic database backups',
  'reserved-units': 'Reserved Units - Development 1X',
  'reserved-units-standard-2x': 'Reserved Units - Development 2X',
  'reserved-units-standard-3x': 'Reserved Units - Production 3X',
  'reserved-units-standard-4x': 'Reserved Units - Production 4X',
  'reserved-units-performance-1x': 'Reserved Units - Performance 1X',
  'reserved-units-performance-2x': 'Reserved Units - Performance 2X',
};


export const activityTypes = {
  login: 'Dashboard login',
  change_password: 'Password change',
  update_profile: 'Account Info Update',
  update_billing: 'Billing Info Update',
  // create_app,
  // delete_app,
  // update_app_settings,
  // add_collaborator,
  // delete_collaborator,
  // download_invoice,
  activate_backups: 'Automatic Database Backups were successfully activated',
  deactivate_backups: 'Automatic Database Backups were successfully deactivated',
  // create_job,
  // delete_job,
  // run_job,
  preview_export: 'Preview Right to data portability',
  preview_withdraw: 'Preview Right to withdraw consent to the processing of personal data',
  preview_forgot: 'Preview Right "to be forgotten" - for erasure of personal data related to me',
  pin_code: 'Preview Account PIN Code',


  // github_deploy,
  // app_scaleup,
  // app_scaledown,
  // preview_export,
  // preview_withdraw,
  // preview_forgot,
  // pin_code,
  // set_engine,
  // custom
};

export const euCountries = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HU', 'HR', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK'];


export const isoCountries = {
  Afghanistan: 'AF',
  'Aland Islands': 'AX',
  Albania: 'AL',
  Algeria: 'DZ',
  'American Samoa': 'AS',
  Andorra: 'AD',
  Angola: 'AO',
  Anguilla: 'AI',
  Antarctica: 'AQ',
  'Antigua And Barbuda': 'AG',
  Argentina: 'AR',
  Armenia: 'AM',
  Aruba: 'AW',
  Australia: 'AU',
  Austria: 'AT',
  Azerbaijan: 'AZ',
  Bahamas: 'BS',
  Bahrain: 'BH',
  Bangladesh: 'BD',
  Barbados: 'BB',
  Belarus: 'BY',
  Belgium: 'BE',
  Belize: 'BZ',
  Benin: 'BJ',
  Bermuda: 'BM',
  Bhutan: 'BT',
  Bolivia: 'BO',
  'Bosnia And Herzegovina': 'BA',
  Botswana: 'BW',
  'Bouvet Island': 'BV',
  Brazil: 'BR',
  'British Indian Ocean Territory': 'IO',
  'Brunei Darussalam': 'BN',
  Bulgaria: 'BG',
  'Burkina Faso': 'BF',
  Burundi: 'BI',
  Cambodia: 'KH',
  Cameroon: 'CM',
  Canada: 'CA',
  'Canary Islands': 'IC',
  'Cape Verde': 'CV',
  'Cayman Islands': 'KY',
  'Central African Republic': 'CF',
  Chad: 'TD',
  Chile: 'CL',
  China: 'CN',
  'Christmas Island': 'CX',
  'Cocos (Keeling) Islands': 'CC',
  Colombia: 'CO',
  Comoros: 'KM',
  Congo: 'CG',
  'Congo, Democratic Republic': 'CD',
  'Cook Islands': 'CK',
  'Costa Rica': 'CR',
  'Cote D\'Ivoire': 'CI',
  Croatia: 'HR',
  Cuba: 'CU',
  Cyprus: 'CY',
  'Czech Republic': 'CZ',
  Denmark: 'DK',
  Djibouti: 'DJ',
  Dominica: 'DM',
  'Dominican Republic': 'DO',
  Ecuador: 'EC',
  Egypt: 'EG',
  'El Salvador': 'SV',
  'Equatorial Guinea': 'GQ',
  Eritrea: 'ER',
  Estonia: 'EE',
  Ethiopia: 'ET',
  'Falkland Islands (Malvinas)': 'FK',
  'Faroe Islands': 'FO',
  Fiji: 'FJ',
  Finland: 'FI',
  France: 'FR',
  'French Guiana': 'GF',
  'French Polynesia': 'PF',
  'French Southern Territories': 'TF',
  Gabon: 'GA',
  Gambia: 'GM',
  Georgia: 'GE',
  Germany: 'DE',
  Ghana: 'GH',
  Gibraltar: 'GI',
  Greece: 'GR',
  Greenland: 'GL',
  Grenada: 'GD',
  Guadeloupe: 'GP',
  Guam: 'GU',
  Guatemala: 'GT',
  Guernsey: 'GG',
  Guinea: 'GN',
  'Guinea-Bissau': 'GW',
  Guyana: 'GY',
  Haiti: 'HT',
  'Heard Island & Mcdonald Islands': 'HM',
  'Holy See (Vatican City State)': 'VA',
  Honduras: 'HN',
  'Hong Kong': 'HK',
  Hungary: 'HU',
  Iceland: 'IS',
  India: 'IN',
  Indonesia: 'ID',
  'Iran, Islamic Republic Of': 'IR',
  Iraq: 'IQ',
  Ireland: 'IE',
  'Isle Of Man': 'IM',
  Israel: 'IL',
  Italy: 'IT',
  Jamaica: 'JM',
  Japan: 'JP',
  Jersey: 'JE',
  Jordan: 'JO',
  Kazakhstan: 'KZ',
  Kenya: 'KE',
  Kiribati: 'KI',
  Korea: 'KR',
  Kuwait: 'KW',
  Kyrgyzstan: 'KG',
  'Lao People\'s Democratic Republic': 'LA',
  Latvia: 'LV',
  Lebanon: 'LB',
  Lesotho: 'LS',
  Liberia: 'LR',
  'Libyan Arab Jamahiriya': 'LY',
  Liechtenstein: 'LI',
  Lithuania: 'LT',
  Luxembourg: 'LU',
  Macao: 'MO',
  Macedonia: 'MK',
  Madagascar: 'MG',
  Malawi: 'MW',
  Malaysia: 'MY',
  Maldives: 'MV',
  Mali: 'ML',
  Malta: 'MT',
  'Marshall Islands': 'MH',
  Martinique: 'MQ',
  Mauritania: 'MR',
  Mauritius: 'MU',
  Mayotte: 'YT',
  Mexico: 'MX',
  'Micronesia, Federated States Of': 'FM',
  Moldova: 'MD',
  Monaco: 'MC',
  Mongolia: 'MN',
  Montenegro: 'ME',
  Montserrat: 'MS',
  Morocco: 'MA',
  Mozambique: 'MZ',
  Myanmar: 'MM',
  Namibia: 'NA',
  Nauru: 'NR',
  Nepal: 'NP',
  Netherlands: 'NL',
  'Netherlands Antilles': 'AN',
  'New Caledonia': 'NC',
  'New Zealand': 'NZ',
  Nicaragua: 'NI',
  Niger: 'NE',
  Nigeria: 'NG',
  Niue: 'NU',
  'Norfolk Island': 'NF',
  'Northern Mariana Islands': 'MP',
  Norway: 'NO',
  Oman: 'OM',
  Pakistan: 'PK',
  Palau: 'PW',
  'Palestinian Territory, Occupied': 'PS',
  Panama: 'PA',
  'Papua New Guinea': 'PG',
  Paraguay: 'PY',
  Peru: 'PE',
  Philippines: 'PH',
  Pitcairn: 'PN',
  Poland: 'PL',
  Portugal: 'PT',
  'Puerto Rico': 'PR',
  Qatar: 'QA',
  Reunion: 'RE',
  Romania: 'RO',
  'Russian Federation': 'RU',
  Rwanda: 'RW',
  'Saint Barthelemy': 'BL',
  'Saint Helena': 'SH',
  'Saint Kitts And Nevis': 'KN',
  'Saint Lucia': 'LC',
  'Saint Martin': 'MF',
  'Saint Pierre And Miquelon': 'PM',
  'Saint Vincent And Grenadines': 'VC',
  Samoa: 'WS',
  'San Marino': 'SM',
  'Sao Tome And Principe': 'ST',
  'Saudi Arabia': 'SA',
  Senegal: 'SN',
  Serbia: 'RS',
  Seychelles: 'SC',
  'Sierra Leone': 'SL',
  Singapore: 'SG',
  Slovakia: 'SK',
  Slovenia: 'SI',
  'Solomon Islands': 'SB',
  Somalia: 'SO',
  'South Africa': 'ZA',
  'South Georgia And Sandwich Isl.': 'GS',
  Spain: 'ES',
  'Sri Lanka': 'LK',
  Sudan: 'SD',
  Suriname: 'SR',
  'Svalbard And Jan Mayen': 'SJ',
  Swaziland: 'SZ',
  Sweden: 'SE',
  Switzerland: 'CH',
  'Syrian Arab Republic': 'SY',
  Taiwan: 'TW',
  Tajikistan: 'TJ',
  Tanzania: 'TZ',
  Thailand: 'TH',
  'Timor-Leste': 'TL',
  Togo: 'TG',
  Tokelau: 'TK',
  Tonga: 'TO',
  'Trinidad And Tobago': 'TT',
  Tunisia: 'TN',
  Turkey: 'TR',
  Turkmenistan: 'TM',
  'Turks And Caicos Islands': 'TC',
  Tuvalu: 'TV',
  Uganda: 'UG',
  Ukraine: 'UA',
  'United Arab Emirates': 'AE',
  'United Kingdom': 'GB',
  'United States': 'US',
  'United States Outlying Islands': 'UM',
  Uruguay: 'UY',
  Uzbekistan: 'UZ',
  Vanuatu: 'VU',
  Venezuela: 'VE',
  'Viet Nam': 'VN',
  'Virgin Islands, British': 'VG',
  'Virgin Islands, U.S.': 'VI',
  'Wallis And Futuna': 'WF',
  'Western Sahara': 'EH',
  Yemen: 'YE',
  Zambia: 'ZM',
  Zimbabwe: 'ZW',
};
